export const emailRegex = new RegExp(/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/);

export const phoneRegex = new RegExp(/^\+?[\d\s-()]+(?:#\d+)?$/im);
export const phoneRegexMessage = "Invalid phone number. Please use digits 0-9, spaces, hyphens, parentheses. Optional extension starts with # followed by digits. E.g. +421 09 1234-1234#1234";

export const linkRegex = new RegExp(/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{1,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/);

// Password policy (2026-08-25): length only -- min 10, max 128 characters. No composition
// requirements and no character whitelist: diacritics, spaces and any special characters
// are all allowed (the password only ever goes to the hasher). Mirrors the backend
// Identity options (RequiredLength = 10, all Require* flags off).
export const passwordRegex = new RegExp(/^.{10,128}$/);
export const passwordRegexMessage = "Password must be at least 10 characters";

export const integerRegex = new RegExp(/^[0-9]+$/);
export const twoDecimalsRegex = new RegExp(/^[0-9]+([.][0-9]{1,2})?$/);
export const threeDecimalsRegex = new RegExp(/^[0-9]+([.][0-9]{1,3})?$/);
export const upToTenThousandRegex = new RegExp(/^(?:[1-9][0-9]{0,3})$/);
